import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum OfferSourceId {
  EMAIL = 1,
  PHONE = 2,
  WEBSITE = 3,
  OTHER = 4,
}

export class OfferSource extends Codebook<OfferSourceId> {
  static readonly EMAIL = new OfferSource(OfferSourceId.EMAIL, () => $t('E-mail'))
  static readonly PHONE = new OfferSource(OfferSourceId.PHONE, () => $t('Phone'))
  static readonly WEBSITE = new OfferSource(OfferSourceId.WEBSITE, () => $t('Website'))
  static readonly OTHER = new OfferSource(OfferSourceId.OTHER, () => $t('Other'))

  private constructor(
    id: OfferSourceId,
    public readonly name: () => string,
  ) {
    super(id)
  }
}
